<template>
    <CqModal :showModal="show" heading="Foutmelding" errorModal :preventClosing="isFatal" @closeModal="closeModal">
        <div>{{ message }}</div>
    </CqModal>
</template>

<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator';
    import {CqButton, CqButtonBar, CqModal} from '@cquential/ui';
    import {ApiError, HttpStatusCode} from '@cquential/api';

    @Component({
        components: {
            CqButton,
            CqButtonBar,
            CqModal,
        },
    })
    export default class GlobalErrorModal extends Vue {
        private static instance: GlobalErrorModal | null;

        public show: boolean = false;
        public isFatal: boolean = false;
        public message: string | null = null;

        public mounted(): void {
            GlobalErrorModal.instance = this;
        }

        public beforeUnmount(): void {
            GlobalErrorModal.instance = null;
        }

        public closeModal(): void {
            this.show = false;
        }

        public static open(message: string, isFatal: boolean = false): void {
            this.instance!.message = message;
            this.instance!.show = true;
            this.instance!.isFatal = isFatal;
        }

        public static globalErrorHandler(e: unknown): void {
            if (!(e instanceof ApiError) || !e.response) {
                throw e;
            }

            switch (e.response.rawResponse.status) {
                case HttpStatusCode.Unauthorized:
                    // TODO make nicer flow when Planbord is a stand-alone application (in which case this will be much rarer as tokens will stay valid for longer than a normal session does)
                    GlobalErrorModal.open('De sessie is verlopen. Log opnieuw in en ververs het Planbord.', true);

                    return;
                case HttpStatusCode.Forbidden:
                    GlobalErrorModal.open('Er is geen toestemming voor de uitgevoerde actie. Vraag een beheerder om rechten toe te kennen.');

                    return;
                case HttpStatusCode.NotImplemented:
                    GlobalErrorModal.open('De uitgevoerde actie is niet beschikbaar. Vraag de applicatiebeheerder naar meer informatie.');

                    return;
                default:
                    throw e;
            }
        }
    }
</script>
